module.exports = __webpack_public_path__ + "img/center_day.91a5bdc0.png";